import { render } from "./TestOverview.vue?vue&type=template&id=20ffd701"
import script from "./TestOverview.vue?vue&type=script&lang=js"
export * from "./TestOverview.vue?vue&type=script&lang=js"
script.render = render

export default script